<template>
  <search-group @search="findData" @clear="clearValue" :span="24" :btnSpan="6" :inline="false" multipleLines   :btnOffset="18">
    <Row class="mb16" :gutter="16">
      <Col span="4">
        <Select v-model="searchData.projectFid" placeholder="请选择项目">
          <Option value>请选择</Option>
          <Option
            v-for="({value,text},index) in projectList"
            :key="'prj'+index"
            :value="value"
          >{{text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.pzoEmpCode" filterable placeholder="请选择管家">
          <Option value>请选择</Option>
          <Option v-for="({text,value},index) in zoEmpList" :key="'pzo'+index" :value="value">{{text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.auditStatus" placeholder="请选择审核状态">
          <Option value>请选择</Option>
          <Option v-for="({text,value},index) in auditStatusList" :key="'aud'+index" :value="value">{{text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.isShow" placeholder="请选择显隐状态">
          <Option value>请选择</Option>
          <Option :value="1">显示</Option>
           <Option :value="0">隐藏</Option>
        </Select>
      </Col>
      <Col span="4">
        <DatePicker
          style="width:100%"
           type="daterange"
          placeholder="请选择创建时间"
          format="yyyy-MM-dd"
          v-model="searchData.queryTime"
        ></DatePicker>
      </Col>
    </Row>
  </search-group>
</template>

<script>
import SearchGroup from "components/SearchGroup/index";
import { getProjects } from "../../../../api/common";
import {getZoEmp,getAuditStatus} from "../../../../api/evaluation";
export default {
  components: {
    SearchGroup
  },
  data() {
    return {
      //项目列表数据源
      projectList: [],
      //管家列表数据源
      zoEmpList:[],
       //文件审核状态数据源
      auditStatusList:[],
      //查询数据参数
      searchData: {
        projectFid:'',
        pzoEmpCode:'',
        auditStatus:'',//审核状态 （0 待审核； 1 审核通过； 2 审核驳回 ）
        isShow:'',
        endTime:'',
        queryTime:['',''],
      }
    };
  },
  watch:{
'searchData.projectFid':{
  handler(v){
    this.getZoEmp(v)
  }
}
  },
  created(){
    this.findData();
    this.initProject();
    this.getAuditStatus();
  },
  methods: {
    findData() {
     this.$emit('queryData',this.searchData)
    },
    clearValue() {
      this.searchData = {
        projectFid:'',
        pzoEmpCode:'',
        auditStatus:'',
        isShow:'',
        endTime:'',
        queryTime:['',''],
      };
    },
    initProject() {
      getProjects().then(res => {
        this.projectList = res.data;
      });
    },
    getZoEmp(projectFid){
      getZoEmp({projectFid}).then(res=>{
        this.zoEmpList=res.data
      })
    },
    getAuditStatus(){
        getAuditStatus().then(res=>{
        this.auditStatusList=res.data
      })
    }
  }
};
</script>

<style>
</style>